import { Link } from 'react-router-dom';

const ExternalLink = ({ color, children, ...props }) => (
  <a
    className={`colored-link text-color-${color}`}
    rel="noopener noreferrer"
    target="_blank"
    {...props}
  >
    {children}
  </a>
);

export default ExternalLink;
